import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import AuthLayout from "./AuthLayout";
import { registerCompany, detailByZip } from "../../api/auth";

// Mirrors ordr-flutter lib/auth/signup/company/company_info_screen.dart
export default function CompanySetup() {
	const navigate = useNavigate();
	const [form, setForm] = useState({ corporateName: "", mailingAddress: "", city: "", state: "", zip: "" });
	const [loading, setLoading] = useState(false);
	const [zipLookupLoading, setZipLookupLoading] = useState(false);

	const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

	const handleZipBlur = async () => {
		if (!form.zip || form.zip.length < 5) return;
		setZipLookupLoading(true);
		const res = await detailByZip({ zip: form.zip });
		setZipLookupLoading(false);
		if (res && !res.error && res.data) {
			setForm((f) => ({ ...f, city: res.data.city || f.city, state: res.data.state || f.state }));
		}
	};

	const submit = async (e) => {
		e.preventDefault();
		if (!form.corporateName || !form.mailingAddress || !form.city || !form.state || !form.zip) {
			toast.error("Fill in all company details");
			return;
		}
		setLoading(true);
		const res = await registerCompany(form);
		setLoading(false);
		if (res && !res.error) {
			toast.success("Company registered");
			navigate("/");
		} else {
			toast.error(res?.msg || "Could not register company");
		}
	};

	return (
		<AuthLayout heading="Set up your company" subheading="Tell us about your business so sellers can find and bid on your orders">
			<form onSubmit={submit}>
				<div className="mb-2">
					<label className="form-label">Corporate / legal name</label>
					<input className="form-control" value={form.corporateName} onChange={set("corporateName")} />
				</div>
				<div className="mb-2">
					<label className="form-label">Mailing address</label>
					<input className="form-control" value={form.mailingAddress} onChange={set("mailingAddress")} />
				</div>
				<div className="row g-2 mb-3">
					<div className="col-4">
						<label className="form-label">Zip</label>
						<input className="form-control" value={form.zip} onChange={set("zip")} onBlur={handleZipBlur} />
					</div>
					<div className="col-4">
						<label className="form-label">City {zipLookupLoading ? "..." : ""}</label>
						<input className="form-control" value={form.city} onChange={set("city")} />
					</div>
					<div className="col-4">
						<label className="form-label">State</label>
						<input className="form-control" value={form.state} onChange={set("state")} />
					</div>
				</div>
				<button type="submit" className="btn-accent-solid w-100" disabled={loading}>
					{loading ? "Saving..." : "Continue"}
				</button>
				<button type="button" className="btn-outline w-100 mt-2" onClick={() => navigate("/")}>
					Skip for now
				</button>
			</form>
		</AuthLayout>
	);
}
